var _defs, _path, _path2, _path3, _path4, _line, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrierIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.54 18.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5e6262;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carrier-icn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.72,17.31H23.15l1.74-1,.28-2.78L25,10.44a1.52,1.52,0,0,0-.63-1.18l-.69-.56L20.65,4.33a2.28,2.28,0,0,0-1.94-1L8.3,3.22a2.31,2.31,0,0,0-2,1L3.16,8.77l-.69.56a1.3,1.3,0,0,0-.56,1l-.28,3.26.28,2.85Z",
    transform: "translate(-1.13 -2.72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.3,16.9,19,13.7A1.6,1.6,0,0,0,17.67,13H8.92a1.56,1.56,0,0,0-1.25.69L6.42,16.76",
    transform: "translate(-1.13 -2.72)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.75,16.06v3.47A1.19,1.19,0,0,1,24,20.64l-.21.07a1.91,1.91,0,0,1-1.25,0h-.07a1.26,1.26,0,0,1-.83-1.25v-2",
    transform: "translate(-1.13 -2.72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.91,16.06v3.47a1.19,1.19,0,0,0,.76,1.11l.14.07a1.91,1.91,0,0,0,1.25,0h.07A1.26,1.26,0,0,0,5,19.46v-2",
    transform: "translate(-1.13 -2.72)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.88,
    y1: 5.5,
    x2: 2.58,
    y2: 5.36
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.62,
    cy: 8.74,
    r: 1.44
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.57,
    cy: 8.74,
    r: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierIcn);
export default __webpack_public_path__ + "static/media/carrier-icn.73651cb1ba4e3e008172974216929fd4.svg";
export { ForwardRef as ReactComponent };